import React, { useEffect, useRef } from 'react';

import { useTimer } from '../../context/TimerContext';

import { usePageControl } from '../../context/PageControlContext';
import PageNavigation from '../../components/PageNavigation';

// Go to the next page X seconds after video ends (1 of 4)
import { useNavigate, useLocation } from 'react-router-dom';
import { activePages } from '../../pageConfig'; // same list used in PageNavigation.js

function Module1() {

  // Page nav control
  const { canContinue, setCanContinue } = usePageControl();
  
  useEffect(() => {
    setCanContinue(true);
  }, [setCanContinue]);

  // Go to the next page X seconds after video ends (2 of 4)
  /* Navigation */
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname.replace('/', '');
    const currentIndex = activePages.indexOf(currentPath); 
      
    const handleContinue = () => {
      if (currentIndex < activePages.length - 1) {
        navigate(`/${activePages[currentIndex + 1]}`);
      }
    };
  
  // Video Player
  const videoRef = useRef(null);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play(); // Plays the video
    }
  };

  // Go to the next page X seconds after video ends (3 of 4)
  const inlineTimeoutRef = useRef(null);

  const handleInlineVideoEnded = (delaySeconds = 0) => {
    /* Clear any existing inlineTimeout */
    if (inlineTimeoutRef.current) {
      clearTimeout(inlineTimeoutRef.current);
      inlineTimeoutRef.current = null;
    }

    if (delaySeconds > 0) {
      inlineTimeoutRef.current = setTimeout(() => {
        handleContinue();
        inlineTimeoutRef.current = null;
      }, delaySeconds * 1000);
    } else {
      handleContinue();
    }
  };

  /* Clear inlineTimeout if user manually navigates to new page (= unmounts) when timeout is running */
  useEffect(() => {
  return () => {
    if (inlineTimeoutRef.current) {
      clearTimeout(inlineTimeoutRef.current);
    }
  };
}, []);



  // Timer
  const { timeRemaining, formatTime, isRunning } = useTimer();

  // Determine additional classes dynamically
  let additionalClasses = '';
    if (isRunning) {
      additionalClasses += ' timer-running';
    }
    if (timeRemaining <= 600 && timeRemaining >= 0) { // 10 mins or less but not negative
      additionalClasses += ' timer-warning';
    }
    if (timeRemaining < 0) { // time exceeded
      additionalClasses += ' timer-exceeded';
    } 


  return (
    <div id="module-20" className="page physical">

    {/* -- Background animation -- */}
    {/* 
    <div id="anim-dots-1" className="anim-dots"></div>
    <div id="anim-dots-2" className="anim-dots"></div>
    <div id="anim-dots-3" className="anim-dots"></div>
    <div id="anim-dots-4" className="anim-dots"></div>
    <div id="anim-dots-5" className="anim-dots"></div>
    <div id="anim-dots-6" className="anim-dots"></div> */}
        
        <header className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="CER"></div>
                  <div id="line"></div>
                  <div className={`timer-display${additionalClasses}`}>
                    <span className="timer-text">Time remaining <span className="timer-numbers">{formatTime(timeRemaining)}</span></span>
                  </div>
                </div>
            </div>
        </header>
    
        <main className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="box-wrapper-tv">
                      <video
                        controls
                        autoPlay
                        onEnded={() => handleInlineVideoEnded(5)}  /* Go to the next page X seconds after video ends (4 of 4) */
                        controlsList="nodownload nofullscreen noremoteplayback"
                        disablePictureInPicture
                      >
                        <source src={`/videos/01-news-reporter.mp4`} type="video/mp4" />
                        Your browser does not support the video tag.
                        <track src={`/videos/01-news-reporter.vtt`} kind="subtitles" srcLang="en" label="English" default></track>
                      </video>
                  </div>
                </div>
            </div>
        </main>

        <footer className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <PageNavigation />
                </div>
            </div>
        </footer>
    
    </div>
  );
};

export default Module1;
